import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { getMonthlyBatchSales } from "../../../../../api";
import useMerchantStore from "../../../../stores/merchant";

const SalesSplineChart = () => {
  const activeApp = useMerchantStore((state) => state.activeApp);
  const [salesData, setSalesData] = useState([]);

  useEffect(() => {
    if (activeApp.id) {
      getMonthlyBatchSales({
        powerapp_id: activeApp.id,
        year: null,
      }).then((response) => {
        if (response.status) {
          setSalesData(response.data);
        }
        console.log("response", response);
      });
    }
  }, []);

  const chartOptions = {
    chart: {
      type: "line",
      height: 350,
      toolbar: { show: false },
    },
    colors: ["#4C70EF", "#E03B24", "#EBB800"],
    stroke: {
      curve: "smooth",
      width: 3,
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.3,
        gradientToColors: ["#4C70EF"],
        opacityFrom: 0.4,
        opacityTo: 0,
      },
    },
    grid: {
      borderColor: "#EDEDED",
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        formatter: (value) => `${value} ${new Date().getFullYear()}`,
        style: {
          colors: "#888",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (value) => `$${value}`,
        style: {
          colors: "#888",
        },
      },
      // min: 420,
      // max: 520,
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "left",
      fontSize: "12px",
      fontFamily: "Work Sans",
      fontWeight: 400,

      labels: {
        colors: "#666",
      },
    },
    dataLabels: {
      enabled: false,
    },
  };

  const series = [
    {
      name: "Sales",
      data: salesData,
    },
    // {
    //   name: "Chargebacks",
    //   data: [430, 435, 445, 440, 438],
    // },
    // {
    //   name: "Refunds",
    //   data: [425, 428, 430, 429, 431],
    // },
  ];

  return (
    <div>
      <Chart options={chartOptions} series={series} type="area" height={350} />
    </div>
  );
};

export default SalesSplineChart;
